import { DataBean } from "../DataBean";

export class ProofAccounts extends DataBean {

  public async getProofAccountsCatalogPorPropiedadesRender(mapa:any): Promise<any> {
    return this.getCustomService("ProofERP","java.util.List_getProofAccountsCatalogPorPropiedadesRender_java.util.Map_Number",
      [mapa,null]
    );
  }
  public async createProoByActa(idTest:number,idEmployee:number,idActaCredito:number): Promise<any> {
    return this.getCustomService("ProofERP","void_createProoByActa_Number_Number_Number",
      [idTest,idEmployee,idActaCredito]
    );
  }
  public async sendTestByIDProof(idProof:number,idEmployee:number): Promise<any> {
    return this.getCustomService("ProofERP","void_sendTestByIDProof_Number_Number",
      [idProof,idEmployee]
    );
  }
  public async getResponsesByIDAccount(idTest:number,idAccount:number): Promise<any> {
    return this.getCustomService("ProofERP","java.util.List_getResponsesByIDAccount_Number_Number",
      [idTest,idAccount]
    );
  }
  public async getTestQuestionRender(page:number,rows:number,props:any): Promise<any> {
    return this.getCustomService("ProofERP","com.advantage.shared.Report_getTestQuestionRender_Number_Number_java.util.Map",
      [page,rows,props]
    );
  }


}
